import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

import { ShareRestrictAndCopyButtonPlaceholder } from './shareAndRestrictButton/ShareRestrictAndCopyButtonPlaceholder.tsx';

export const ShareAndRestrictButtonSSRLoader = LoadablePaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareRestrictAndCopyButton" */ './shareAndRestrictButton/ShareRestrictAndCopyCoordinator.tsx'
			)
		).ShareRestrictAndCopyCoordinator,
});

export const ShareAndRestrictButtonLoader = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareRestrictAndCopyButton" */ './shareAndRestrictButton/ShareRestrictAndCopyCoordinator.tsx'
			)
		).ShareRestrictAndCopyCoordinator,
	loading: ShareRestrictAndCopyButtonPlaceholder,
});
